import { gql } from '@apollo/client';

export const BLUETOOTH_LOGGING = gql`
  query BluetoothLoggingEnabled($installationId: UUID!) {
    bluetoothLoggingEnabled(installationId: $installationId)
  }
`;
